import * as React from 'react';
import './styles.css';
import { JSX } from 'react';

export interface IBaseSegmentedItem {
  key: string;
  title: JSX.Element | string;
  icon?: JSX.Element | string;
  addClass?: string;
}

export interface IBaseSegmentedProps {
  items: IBaseSegmentedItem[];
  tabDefaul?: string;
  tab?: string;
  onClick?: (_key: string) => any;
}

export default function BaseSegmented(props: IBaseSegmentedProps) {
  const { items, tab, tabDefaul = '', onClick = () => {} } = props;
  const [active, setActive] = React.useState<string>(tabDefaul);

  React.useEffect(() => {
    if (items.map((i) => i.key).includes(tab as string)) {
      setActive(tab as string);
    }
  }, [items, tab]);

  return (
    <>
      <div className="tl-flex tl-rounded-3xl tl-overflow-hidden tl-bg-white tl-shadow-8 tl-w-fit">
        {items.map((item: IBaseSegmentedItem, i: number) => {
          return (
            <div
              key={i}
              className={`tl-flex tl-z-10 tl-items-center tl-px-4 tl-p-1 tl-relative tl-flex-1 tl-whitespace-nowrap tl-cursor-pointer tl-scroll-snap-none ${
                active === item.key
                  ? 'tl-bg-mint-1 tl-text-mint-13'
                  : 'tl-phr-button-h'
              } ${item.addClass}`}
              onClick={() => {
                onClick(item.key);
                !tab && setActive(item.key);
              }}
            >
              {item.icon}
              {item.title}
            </div>
          );
        })}
      </div>
    </>
  );
}
